import { extractDomain } from "../utils";

export const MIDDLEWARE = "/edge/jobposting/middleware";

export const ENDPOINTS = {
  getUserData: "/cassowary/session/getuser",
  getMasterData: "/edge/recruiter/v4/recruiter-srp/api/v1/master-data",
  getV4MasterData: "/get/alldata",
  getMasterDataRaven: "/v4/recruiter/v4/recruiter-srp/api/v1/ravenMasterData",
  getTitleSkillSuggestion: "/search-service/keyword/suggestion",
  getInventoryAllCount: "/edge-jp/api/jobposting/inventory/all-count",
  jobPost: "/edge-jp/api/jobposting/jp",
  getJobPostList: "/edge-jp/api/jobposting/postedJobList",
  getJobPostCopy: "/edge-jp/api/jobposting/copy",
  getJobPostEdit: "/edge-jp/api/jobposting/edit",
  getAiDescription: "/edge-jp/api/jobposting/ai-generative/description",
  getAiSkills: "/edge-jp/api/jobposting/ai-generative/skills",
  getPerkBenifits: "/edge-jp/api/jobposting/perksandbenefits/all",
  keyWordsAutoLookUp: "/search-service/keyword/lookup",
  getCorpInfo: "/edge-jp/api/jobposting/corp/details",
  jobUpdate: "/edge-jp/api/jobposting/update",
  aiFeedBack: "/edge-jp/api/jobposting/feedback/create",
  getQuestionaireList: "/edge-jp/questionnaire/get-questionnaire-list",
  deleteQuestionaire: "/edge-jp/questionnaire/questionnaire-status",
  mappedQuestionaireToJob: "/edge-jp/questionnaire/active-jobs-list",
  createQuestionnaire: "/edge-jp/questionnaire/",
  attachQuestionnaire: "/edge-jp/questionnaire/map",
  getQuestionnaireJobList:
    "/edge-jp/questionnaire/get-questionnaire-jobs-list",
  fetchQuestionnaire: "/edge-jp/questionnaire",
  healthTracker: "/recruiter-edge-event-tracking/api/v1/tracking/page/load/event",
  createFolder: "/recruiter-edge-actions/api/v1/folder/personal",
  updateFolder:"/edge-folder-management/api/v2/folder/personal",
  getFolderName:'/edge-folder-management/api/v2/folder',
  getAllFolders: "/edge-jp/api/jobposting/folderDetails",
  getEJP:"/edge-hoatzin/inventory/edge/purchased/corporate",
  jobPreferences: "/recruiter_admin_apis/job_preferences/",
};

export const API_HEADERS: HeadersInit | undefined = {
  domain: extractDomain(),
};
